/* PPV search - fetch published Shopify collection JSON; avoid stale stored catalogs. */
(function(){
"use strict";
const quarterHandles=["da-gennaio-a-marzo","da-aprile-a-giugno","da-luglio-a-settembre","da-ottobre-a-dicembre"];
const seasonHandles=[...quarterHandles,"capodanno"];
const holidayHandles=["pasqua","25-aprile","1-maggio","2-giugno","ferragosto","halloween","capodanno"];
const selectableHandles=Array.from(new Set([...seasonHandles,...holidayHandles]));
const destinations=["islanda","lapponia","giappone","new-york","parchi-ovest","messico"];
const prettyDestination={"islanda":"Islanda","lapponia":"Lapponia","giappone":"Giappone","new-york":"New York","parchi-ovest":"Parchi dell'Ovest","messico":"Messico"};
const months={gennaio:0,febbraio:1,marzo:2,aprile:3,maggio:4,giugno:5,luglio:6,agosto:7,settembre:8,ottobre:9,novembre:10,dicembre:11};
const norm=x=>String(x||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase();
function destination(p){
 const tags=Array.isArray(p.tags)?p.tags.join(" "):String(p.tags||"");
 const title=norm((p.title||"")+" "+(p.product_type||""));
 const tagStr=norm(tags);
 for(const key of destinations)if(tagStr.includes("destinazione:"+key)||tagStr.includes("destinazione: "+norm(prettyDestination[key])))return key;
 if(/parchi dell|stati uniti.*parchi/.test(title))return "parchi-ovest";
 if(/new york|nyc|manhattan/.test(title))return "new-york";
 if(/messico|mexico|yucatan/.test(title))return "messico";
 if(/islanda|iceland/.test(title))return "islanda";
 if(/lapponia|rovaniemi|laponia/.test(title))return "lapponia";
 if(/giappone|japan|tokyo|kyoto|okinawa/.test(title))return "giappone";
 return "";
}
function ppvStructuredDate(handle){
 try{
  const element=document.getElementById("ppv-trip-date-map");
  if(!element)return null;
  if(!window.__ppvTripDatesParsed){
   window.__ppvTripDatesParsed=JSON.parse(element.textContent||"{}");
  }
  const start=window.__ppvTripDatesParsed[String(handle)]?.start;
  if(!/^\d{4}-\d{2}-\d{2}$/.test(start||""))return null;
  const [year,month,day]=start.split("-").map(Number);
  const date=new Date(year,month-1,day);
  return date.getFullYear()===year && date.getMonth()===month-1 && date.getDate()===day ? date:null;
 }catch(error){return null;}
}
function dateFromISO(value){
 if(!/^\d{4}-\d{2}-\d{2}$/.test(value||""))return null;
 const [year,month,day]=value.split("-").map(Number);
 const date=new Date(year,month-1,day);
 return date.getFullYear()===year&&date.getMonth()===month-1&&date.getDate()===day?date:null;
}
function getStructuredRange(p){
 try{
  const el=document.getElementById("ppv-trip-date-map");
  if(!el)return null;
  if(!window.__ppvTripDatesParsed)window.__ppvTripDatesParsed=JSON.parse(el.textContent||"{}");
  const entry=window.__ppvTripDatesParsed[String(p.handle)];
  if(!entry)return null;
  const start=dateFromISO(entry.start),end=dateFromISO(entry.end);
  return start&&end&&end>=start?{start,end}:null;
 }catch(error){return null;}
}
function easterSunday(year){
 // Meeus/Jones/Butcher Gregorian Easter algorithm.
 const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4;
 const f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30;
 const i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k+7)%7;
 const m=Math.floor((a+11*h+22*l)/451);
 const month=Math.floor((h+l-7*m+114)/31),day=((h+l-7*m+114)%31)+1;
 return new Date(year,month-1,day);
}
function holidayDate(handle,year){
 if(handle==="pasqua")return easterSunday(year);
 const dates={"25-aprile":[3,25],"1-maggio":[4,1],"2-giugno":[5,2],"ferragosto":[7,15],"halloween":[9,31],"capodanno":[0,1]};
 const spec=dates[handle];
 return spec?new Date(year,spec[0],spec[1]):null;
}
function matchesPeriod(product,when){
 if(!when)return true;
 const range=getStructuredRange(product),start=range?.start||startDate(product);
 if(!start)return false;
 if(quarterHandles.includes(when)){
  const quarter=["da-gennaio-a-marzo","da-aprile-a-giugno","da-luglio-a-settembre","da-ottobre-a-dicembre"].indexOf(when);
  return quarter>=0&&Math.floor(start.getMonth()/3)===quarter;
 }
 if(holidayHandles.includes(when)){
  const end=range?.end||start;
  for(let year=start.getFullYear();year<=end.getFullYear();year++){
   const holiday=holidayDate(when,year);
   if(!holiday)continue;
   if(holiday>=start&&holiday<=end)return true;
   if(when==="pasqua"){
    const monday=new Date(year,holiday.getMonth(),holiday.getDate()+1);
    if(monday>=start&&monday<=end)return true;
   }
  }
 }
 return false;
}
function startDate(p){
 const trusted=ppvStructuredDate(p.handle);
 if(trusted)return trusted;
 const t=norm(p.title);
 const match=t.match(/(?:dal|dall|dalla|dallo)[’']?\s*(\d{1,2})(?:\s+(?:al|a|all)[’']?\s*\d{1,2})?\s*(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/);
 if(!match)return null;
 const day=Number(match[1]),mo=months[match[2]];
 const years=[...t.matchAll(/\b20\d{2}\b/g)].map(x=>({y:Number(x[0]),at:x.index}));
 if(!years.length)return null;
 let year=years[0].y;
 const nearby=years.find(x=>x.at>=match.index+match[0].length && x.at<=match.index+match[0].length+10);
 if(nearby)year=nearby.y;
 else if(years.length===1&&mo>=10){
  const after=t.slice(match.index+match[0].length);
  if(/gennaio|febbraio|marzo/.test(after)&&months[match[2]]>=10)year--;
 }
 if(day<1||day>31)return null;
 const date=new Date(year,mo,day);
 return date.getFullYear()===year&&date.getMonth()===mo&&date.getDate()===day?date:null;
}
async function getSeason(handle){
 const all=[];let p=1;
 while(p<=7){
  const response=await fetch("/collections/"+encodeURIComponent(handle)+"/products.json?limit=250&page="+p,{credentials:"same-origin",headers:{"Accept":"application/json"}});
  if(!response.ok)throw Error("HTTP "+response.status);
  const data=await response.json();
  if(!data||!Array.isArray(data.products))throw Error("Risposta non valida");
  all.push(...data.products);
  if(data.products.length<250)break;
  p++;
 }
 return all.map(x=>({...x,__season:handle}));
}
const getImage=p=>{
 const img=p.images&&p.images[0];
 return typeof img==="string"?img:(img?.src||p.image?.src||p.featured_image?.src||"");
};
function mk(tag,cls,content){const el=document.createElement(tag);if(cls)el.className=cls;if(content!=null)el.textContent=content;return el;}
function isSoldOut(product){
 if(Array.isArray(product.variants)&&product.variants.some(v=>typeof v.available==="boolean")){
   return !product.variants.some(v=>v.available===true);
 }
 return product.available===false;
}
function card(product){
 const a=mk("a","ppv-finder__card");a.href="/products/"+encodeURIComponent(product.handle);
 const img=getImage(product);
 if(img){const image=document.createElement("img");image.src=img;image.alt=product.title||"Viaggio";image.className="ppv-finder__card-image";image.loading="lazy";a.appendChild(image)}
 const b=mk("div","ppv-finder__card-body");
 b.appendChild(mk("div","ppv-finder__card-title",product.title));
 if(isSoldOut(product))b.appendChild(mk("span","ppv-finder__soldout","Posti esauriti"));
 const d=startDate(product),dest=destination(product);
 const details=[dest?prettyDestination[dest]:"",d?d.toLocaleDateString("it-IT",{day:"numeric",month:"long",year:"numeric"}):""].filter(Boolean);
 if(details.length)b.appendChild(mk("div","ppv-finder__card-info",details.join(" · ")));
 b.appendChild(mk("div","ppv-finder__card-link","Scopri il viaggio →"));a.appendChild(b);return a;
}
async function render(root){
 const form=root.querySelector("form"),grid=root.querySelector("[data-ppv-grid]"),status=root.querySelector("[data-ppv-status]");
 const qs=new URLSearchParams(location.search);
 let dest=qs.get("dove")||"",when=qs.get("quando")||"";
 if(!destinations.includes(dest))dest="";
 if(!selectableHandles.includes(when))when="";
 form.elements.dove.value=dest;form.elements.quando.value=when;
 const chosen=["all"]; // Seasonal and holiday classification is derived from dates, not manual collection membership.
 status.textContent="Caricamento delle partenze in programma...";
 const results=await Promise.allSettled(chosen.map(getSeason));
 const failures=results.filter(x=>x.status==="rejected").length;
 const all=results.flatMap(x=>x.status==="fulfilled"?x.value:[]);
 const unique=new Map();
 for(const p of all){if(p&&p.handle&&p.title&&!unique.has(p.handle))unique.set(p.handle,p)}
 const cutoff=new Date();cutoff.setHours(0,0,0,0);
 const filtered=[...unique.values()].filter(p=>{
   const date=startDate(p);
   if(!date||date<cutoff)return false;
   if(dest&&destination(p)!==dest)return false;
   if(!matchesPeriod(p,when))return false;
   return true;
 }).sort((a,b)=>(startDate(a)?.getTime()||9999999999999)-(startDate(b)?.getTime()||9999999999999));
 grid.replaceChildren();
 if(!filtered.length){
  const div=mk("div","ppv-finder__empty","Non risultano partenze per questa combinazione. Prova un'altra destinazione o un altro periodo. ");
  const link=mk("a","","Vedi tutte le partenze");link.href="/pages/tutte-le-partenze";div.appendChild(link);grid.appendChild(div);
 }else for(const p of filtered)grid.appendChild(card(p));
 const soldOutCount=filtered.filter(isSoldOut).length;
 status.textContent=filtered.length+" "+(filtered.length===1?"partenza trovata":"partenze trovate")+(soldOutCount?" ("+soldOutCount+" con posti esauriti)":"")+(failures?" · Alcune partenze potrebbero non essere caricate.":"");
}
function init(){
 document.querySelectorAll("[data-ppv-finder]").forEach(root=>{
  if(root.dataset.ppvReady)return;root.dataset.ppvReady="true";
  if(root.dataset.mode!=="results")return;
  const form=root.querySelector("form");
  form.addEventListener("submit",event=>{
   event.preventDefault();
   const q=new URLSearchParams(new FormData(form));
   history.replaceState(null,"",location.pathname+"?"+q);
   render(root).catch(()=>showError(root));
  });
  render(root).catch(()=>showError(root));
 });
}
function showError(root){
 const status=root.querySelector("[data-ppv-status]");if(status)status.textContent="Impossibile caricare automaticamente le partenze. Puoi consultarle dalla pagina Tutte le partenze.";
 const grid=root.querySelector("[data-ppv-grid]");
 if(grid){const a=mk("a","","Apri tutte le partenze");a.href="/pages/tutte-le-partenze";grid.replaceChildren(a)}
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init);else init();
document.addEventListener("shopify:section:load",init);
})();